<div class="align-items-center flex justify-content-start">
<!--  <div class="col-2"></div>-->
    <div class="col-2 viewBy-filter">
    <div class="field">
      <label>View By</label>
      <p-dropdown (onChange)="routeTo(selectViewByVisits)" [(ngModel)]="selectViewByVisits" [options]="viewByVisitDropdown" ngDefaultControl></p-dropdown>
    </div>
  </div>
  <div class="col-4">
    <div class="field">
      <ng-container>
        <label>Patient</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img alt="search.svg" src="../../assets/images/search.svg"/></span>
          <input (keyup)="searchByPatient(searchPatient)" [(ngModel)]="searchPatient" [placeholder]="onlyAdminRoles() ? searchUnmatchedVisitByID : searchPatientByMRN"
                 class="table-search-field w-full" type="text"/>
        </div>
      </ng-container>
    </div>
  </div>
     <div class="col-3" >
     <div class="field" >
       <ng-container>
         <label>Clinician</label>
         <div class="p-inputgroup table-search-wrapper">
           <span class="p-inputgroup-addon"><img alt="search.svg" src="../../assets/images/search.svg"/></span>
           <input (keyup)="searchByPatient(searchByClinician)" [(ngModel)]="searchByClinician" [placeholder]="searchByClinicianPlaceHolder"
                  class="table-search-field w-full" type="text"/>
         </div>
       </ng-container>
     </div>
   </div>
  <div class="col-3">
    <div class="field">
      <label>Date</label>
      <div class="p-inputgroup table-calendar-wrapper">
        <span class="p-inputgroup-addon"><img alt="calendar.svg" src="assets/images/calendar.svg"/></span>
        <p-calendar (onClear)="onCalendarClear()" (onSelect)="selectVisitDate()" [(ngModel)]="rangeDates" [readonlyInput]="true" class="w-full" dateFormat="{{datePickerFormat}}" inputId="range" ngDefaultControl placeholder="{{datePickerPlaceholder}}" selectionMode="range"></p-calendar>
        <button (click)="onCalendarClear()" *ngIf="rangeDates != null" class="clearBtn">
          <img alt="" src="assets/images/error.svg">
        </button>
      </div>

    </div>
  </div>
</div>

<div class="table-wrapper">
  <div class="table-header">
    <div class="align-items-center flex">
      <h2>{{ viewByVisitDropdown[1].label }}</h2>
      <div class="user-label">
        <img alt="mdi_user.svg" src="../../assets/images/mdi_user.svg"/>
        <span>{{ totalUnMatchedVisits }}</span>
      </div>
    </div>
  </div>
  <p-table #dt [(selection)]="selectedSubmissions" [value]="unmatchedVisits" class="visitListingTable" dataKey="id">
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th class="w-10rem" id="visitType">
          <div class="flex align-items-center gap-2">
            <span>Visit Type</span>
            <div class=" filterClass dd-align-right">
              <img class="w-16" *ngIf="!selectedSubmissionTypes || !selectedSubmissionTypes.length"
                   (click)="typeDropdown.show()" src="assets/images/filter-outline.svg">
              <img class="w-18" *ngIf="selectedSubmissionTypes && selectedSubmissionTypes.length && selectedSubmissionTypes.length > 0"
                   (click)="typeDropdown.show()" src="assets/images/filter-filled.svg">
              <p-multiSelect #typeDropdown (onPanelHide)="sortSelectedVisits()"
                             (onChange)="onSubmissionTypeDropdownChange()"
                             [(ngModel)]="selectedSubmissionTypes" [options]="submissionTypes"
                             appendTo="body" optionLabel="label" styleClass="typeMulitselect-dd">
                <ng-template pTemplate="header">
                  <span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues()"><img src="assets/images/filter-icn.svg" alt="exclamation.svg"></span>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </th>
        <th class="w-11rem" id="visitDate">Visit Date</th>
        <th class="w-15rem" id="MRN">
          <div *ngIf="!allowAdminRoles; else elseBlock">
            MRN
          </div>
          <ng-template #elseBlock>
            <div>
              ID
            </div>
          </ng-template>
        </th>
        <ng-container *ngIf="allowAdminRoles">
          <th class="w-10rem" id="map">Map</th>
        </ng-container>
        <th class="w-12rem" id="lastUpdated">Last updated at</th>
        <th class="w-12rem" id="submittedBy">Submitted By</th>
<!--        <th class="w-10rem">-->
<!--          <div class="flex align-items-center gap-2">-->
<!--            <span>Status</span>-->
<!--            <div class=" filterClass dd-align-right">-->
<!--              <i class="pi pi-filter" (click)="statusDropdown.show()"></i>-->
<!--              <p-dropdown #statusDropdown [(ngModel)]="selectedSubmissionStatus" [autoDisplayFirst]="false"  [options]="submissionStatus" (ngModelChange)="onSubmissionStatusDropdownChange()"></p-dropdown>-->
<!--            </div>-->
<!--          </div>-->
<!--        </th>-->
      </tr>
    </ng-template>
    <ng-template let-rowIndex="rowIndex" let-unmatchedVisit pTemplate="body">
      <tr (click)="unmatchedVisitDetails(unmatchedVisit)" class="p-selectable-row cursor-pointer">
        <td>
          <span class="image-text">{{unmatchedVisit?.submissionData?.visitType}}</span>
        </td>
        <td>
          <span class="image-text">{{unmatchedVisit?.submissionData?.visitDate | customDate: dateFormat}}</span>
        </td>
        <td>
          <div class="flex align-items-center gap-3">
            <div *ngIf="allowAdminRoles; else elseBlock">
              <p class="gc-agency-handle">{{ unmatchedVisit?._id | truncate: defaultPatientIdLength }}</p>
            </div>
            <ng-template #elseBlock>
              <div>
                <p class="gc-agency-handle"><!--MRN:--> {{ unmatchedVisit.submissionData?.mrn | truncate: defaultUnmatchedMrnLength }}</p>
              </div>
              <div class="">
                      <span [escape]="false" class="tooltip-icon" pTooltip="
                      IOH ID: {{unmatchedVisit.submissionData?._id}}<br>MRN: {{ unmatchedVisit?.submissionData.mrn }} "  tooltipStyleClass="eSocMRNToolTip">
                        <img alt="exclamation.svg" src="assets/images/exclamation.svg"></span>
              </div>
            </ng-template>
          </div>
        </td>
        <ng-container *ngIf="allowAdminRoles">
          <td>
            <span class="p-column-title">Google Map</span>
            <div>
              <ng-container *ngIf="unmatchedVisit?.submissionData?.latitude && unmatchedVisit?.submissionData?.longitude; else notApplicableDiv">
                <div (click)="$event.stopPropagation(); patientSubmission = unmatchedVisit; showLocationDialog( unmatchedVisit?.submissionData?.visitDate, unmatchedVisit?.submissionData?.visitType)">
                  <em class="pi pi-map-marker"></em>
                </div>
              </ng-container>
              <ng-template #notApplicableDiv>
                <div (click)="$event.stopPropagation()">Not Applicable</div>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <td>
          <span class="image-text">{{unmatchedVisit?.submissionData?.submissionDate | customDate }}</span>
        </td>
        <td>
          <div>
            <p class="gc-agency-name">{{ (( unmatchedVisit?.firstName ? unmatchedVisit?.firstName : ' ' ) + " " + (unmatchedVisit?.lastName ? unmatchedVisit?.lastName : '' )) | truncate: defaultCaseManagerNameLength }}
            </p>
            <p class="gc-agency-handle">{{ (unmatchedVisit?.defaultRole ? '(' + RoleEnum[unmatchedVisit?.defaultRole] + ')' : '') | truncate: defaultRoleNameLength   }}</p>
          </div>
        </td>
<!--        <td>-->
<!--          <span class="p-column-title">Status</span>-->
<!--          <span class="image-text" [style.color]="submissionStatusColorEnum[statusColor(unmatchedVisit?.submissionData?.status | lowercase)]">{{ getLabelByValue(unmatchedVisit?.submissionData?.status)}}</span>-->
<!--        </td>-->
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: center">
        <span>
          <em class="pi pi-exclamation-circle mr-2"></em>
          No Unmatched Visits found
        </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="paginator-wrapper">
    <p-paginator #paginator (onPageChange)="paginate($event)" [rowsPerPageOptions]="rowsPerPageOptions" [rows]="noOfRecordPerRow" [totalRecords]="totalUnMatchedVisits" styleClass="gc-paginator"></p-paginator>
  </div>
</div>
<p-dialog [(visible)]="locationPopupDisplay" [dismissableMask]="true" [modal]="true" [style]="{ width: '400px' }">
  <ng-template pTemplate="header">
    <span>Visit Type: {{ selectedVisitType }} - Visit Date: {{ selectedVisitDates }}</span>
  </ng-template>
  <!-- <p-gmap *ngIf="locationPopupDisplay" [options]="options" [overlays]="overlays" [style]="{ 'width': '100%', 'height': '320px' }"></p-gmap> -->
  <!-- Google Maps component removed - GMapModule not available in PrimeNG 16+ -->
</p-dialog>
<p-sidebar
  (onHide)="onSlideBarClose()"
  [(visible)]="display"
  [showCloseIcon]="false"
  class="sidebar-lg"
  position="right">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <h2 class="gc-form-heading">Visit Details</h2>
        <span>[{{ patientSubmission?.submissionDate ?  (patientSubmission?.submissionDate | customDate) : (patientSubmission?.submissionData?.submissionDate | customDate)}}]</span>
        <span>{{patientSubmission?.status ? getLabelByValue(patientSubmission?.status) : getLabelByValue(patientSubmission?.submissionData?.status) }}</span>
      </div>
      <div>
        <span (click)="onSlideBarClose()" class="cursor-pointer"><em class="pi pi-times"></em></span>
      </div>
    </div>
    <br />
    <br />
  </ng-template>
  <ng-template pTemplate="content">
    <app-visit-details (closeSideBar)="onSlideBarClose()" (eSOCUploadDisplay)="openeSOCUploadPopup()" (reloadPatientSubmission)="getSubmissionWithOutPatients()" [patientSubmission]="patientSubmission"></app-visit-details>
  </ng-template>
</p-sidebar>

